var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V21H21V0H0ZM17.4451 4.97634L16.3203 6.05653C16.2212 6.12806 16.1733 6.25144 16.1936 6.37088V14.3043C16.1733 14.4277 16.2212 14.5471 16.3203 14.6219L17.4175 15.7021V15.9377H11.8873V15.7021L13.0252 14.5943C13.1381 14.4815 13.1381 14.4506 13.1381 14.28V7.8645L9.96975 15.9101H9.54253L5.85441 7.8645V13.2582C5.82356 13.484 5.89903 13.713 6.05587 13.8771L7.539 15.6752V15.9108H3.33834V15.6752L4.82147 13.8771C4.97897 13.713 5.0505 13.484 5.00916 13.2582V7.02384C5.0295 6.84928 4.96125 6.67866 4.83131 6.5625L3.51553 4.97634V4.73681H7.60331L10.7651 11.6721L13.5437 4.73681H17.4438L17.4451 4.97634Z",
    fill: "#212B42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.c69f57ee69941e7df37a72005d9bcd59.svg";
export { ForwardRef as ReactComponent };